import Logo, { LogoProps } from './Logo';

export type { LogoProps };
export default Logo;
